export enum ServiceAgreementStatusType {
    Active = 'Active',
    Sent = 'Sent',
    Canceled = 'Canceled',
    Fulfilled = 'Fulfilled',
    Invoiced = 'Invoiced',
    Terminated = 'Terminated',
    Unknown = 'Unknown'
  }